// extracted by mini-css-extract-plugin
module.exports = {"spacedButton":"revieve-modal-trigger_spacedButton__vCzUk","bigButton":"revieve-modal-trigger_bigButton__etpnx"};